<template>

	<!-- Page header -->
	<div class="page-header page-header-light shadow">

		<!-- breadcrumb -->
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer"> Tessere </a>
					<span class="hidden-xs ms-1">\</span>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" v-on:click="openRoute('/CardsRange')"> Elenco Renge </a>
					<span class="hidden-xs ms-1">\</span>
					<span class="text-muted ms-1"> Gestione Tessere</span>
             	</h4>
				<a href="#page_header" class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
					<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
				</a>
            </div>
			<div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">
						
					<a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2 position-10" style="text-align: left;">

					</a>
					
					<div class="vr flex-shrink-0 my-2 mx-3"></div>

					<div class="d-inline-flex float-end mt-sm-0">
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill" v-on:click="$root.confTravelTipologiche(10)" title="Opzioni Utenti" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-lightning"></i>
						</a>
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.confTravelLingue(10)" title="Definizioni Lingua" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-flag"></i>
						</a>
						<a href="#" class="btn btn-outline-pink btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.help(10)" title="Help OnLIne" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="icon-question7 pink"></i>
						</a>
					</div>
				</div>
			</div>
		</div>
		<!-- /breadcrumb -->

		<!-- Profile navigation -->
		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation">
						<a href="#tessere-a" class="navbar-nav-link navbar-nav-link-icon navbar-sm active rounded" data-bs-toggle="tab" aria-selected="true" role="tab" tabindex="-1">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="icon-menu7"></i>
								<span class="hidden-lg ms-1">Tessere</span>
								<span class="hidden-xs ms-1"><Translate :path="'dizionario.base.ELENCO'" class="me-1"></Translate>Tessere</span>
							</div>
						</a>
					</li>
					<li class="nav-item me-1" role="presentation">
						<a href="#tessere-b" class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded" data-bs-toggle="tab" aria-selected="false" role="tab" tabindex="-1">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-activity"></i>	
								<span class="hidden-lg ms-1">Stats.</span>
								<span class="hidden-xs ms-1"><Translate :path="'dizionario.base.BTN_STATISTICHE'"></Translate></span>
							</div>
						</a>
					</li> 
					<li class="nav-item d-lg-none ms-auto">
						<a href="#profile_nav" class="navbar-nav-link navbar-nav-link-icon rounded-pill rounded-pill-small collapsed" data-bs-toggle="collapse" aria-expanded="false">
							<i class="ph-caret-down collapsible-indicator"></i>
						</a>
					</li>
				</ul>

				<div class="navbar-collapse collapse" id="profile_nav">
					<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
						<li class="nav-item dropdown ms-lg-1">
							<div class="btn-group">
								<a href="#" class="btn btn-flat-indigo border-transparent btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
									<i class="ph-gear me-1"></i>
									<span style="font-size:0.8rem;">Azioni Multiple</span>
								</a>
								<div class="dropdown-menu dropdown-menu-end" style="">
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i class="far fa-ballot-check fa-fw me-2"></i><span class="text-muted me-1">|</span>Stato</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item"><i class="far fa-check-square fa-fw me-2"></i>Attiva selezionati</a>
											<a href="#" class="dropdown-item"><i class="far fa-square fa-fw me-2"></i>Disattiva selezionati</a>
										</div>
									</div>
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i class="far fa-file-export fa-fw me-2"></i><span class="text-muted me-1">|</span>Comunicazioni</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Stampa scheda</a>
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Invia Email</a>
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Invia SMS</a>
										</div>
									</div>
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i class="far fa-file-export fa-fw me-2"></i><span class="text-muted me-1">|</span>Esporta dati</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Pagina corrente</a>
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Utenti selezionati</a>
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Tutti gli Utenti</a>
										</div>
									</div>
									<div class="dropdown-divider"></div>
									<a href="#" class="dropdown-item"><i class="far fa-trash fa-fw me-2 text-danger"></i><span class="text-muted me-1">|</span>Elimina selezionati</a>
								</div>
							</div>
						</li>
						<li class="nav-item ms-3">
							<select class="form-select form-select-sm" data-placeholder="Seleziona Anno">
								<option>Anno</option>
							</select>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- /profile navigation -->	

	</div>
	<!-- /page header -->

	<!-- Content area -->
    <div class="content content-1 table-cms-wrapper">
		<div class="tab-content flex-1 order-2 order-lg-1">

			<div class="tab-pane fade active show" id="tessere-a">
				<div class="card shadow mb-xs-3 mb-lg-0">
					<div class="card-header d-lg-none p-1">
						<div class="d-grid gap-2">
							<a href="#collapse-all" class="btn btn-flat-info btn-sm collapsed" data-bs-toggle="collapse" role="button" aria-expanded="false">
								MOSTRA FILTRI
							</a>
						</div>
					</div>
					<div class="collapse show" id="collapse-all" style="">				
						<div class="card-body pb-0">
							<div class="alert alert-2 alert-secondary border-0">
								<form autocomplete="off" action="#" id="tessera-a">
									<div class="row">
										<div class="col-12 col-md-1 mbx-1">
											<input autocomplete="off" value="" class="form-control form-control-sm" type="text" placeholder="Ordine Dal" v-model="search.ID_ORDINE.VALUE_DA">
										</div>
										<div class="col-6 col-md-1 mbx-1">
											<input autocomplete="off" value="" class="form-control form-control-sm" type="text" placeholder="Ordine Al" v-model="search.ID_ORDINE.VALUE_A">
										</div>
										<div class="col-6 col-md-3">
											<div class="row">
												<div class="col-6 col-md-6 mbx-1">
													<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Cognome" v-model="search.COGNOME.VALUE" :tabindex="9"  />
												</div>
												<div class="col-6 col-md-6 mbx-1">
													<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Nome" v-model="search.NOME.VALUE" :tabindex="9"  />
												</div>
											</div>
										</div>
										<div class="col-6 col-md-6">
											<div class="row">
												<div class="col-md-3 mbx-1">
													<select class="form-select form-select-sm" data-placeholder="Seleziona Stato Generica" v-model="search.STATO.VALUE">
														<option value="">Seleziona Stato Raspa</option>
														<option value="ACTIVE"> ATTIVE</option>
														<option value="PENDING"> DA ASSEGNARE</option>
													</select>
												</div>
												<div class="col-6 col-md-3 mbx-1">
													<select class="form-select form-select-sm" data-placeholder="Seleziona Tipo Tessera" v-model="search.FK_ID_TIPO.VALUE">
														<option value="">Seleziona Tipo Tessera</option>
														<option value="0"> RASPA</option>
														<option value="1"> WTP</option>
														<option value="2"> GOSKIPASS</option>
													</select>
												</div>
												<div class="col-6 col-md-3 mbx-1">
													<input autocomplete="off" value="" class="form-control form-control-sm" type="text" placeholder="Raspa Dal" v-model="search.NUMERO_TESSERA.VALUE_FROM">
												</div>
												<div class="col-6 col-md-3 mbx-1">
													<input autocomplete="off" value="" class="form-control form-control-sm" type="text" placeholder="Raspa Al" v-model="search.NUMERO_TESSERA.VALUE_TO">
												</div>
											</div>
										</div>
										<div class="col-6 col-md-1 col-lg-1">
			                                <a href="#collapse-a" class="btn btn-flat-info btn-sm w-100 collapsed" data-bs-toggle="collapse" v-on:click="filters.resizeGrid('collapse-a','tableFixHead','box-card')" role="button" aria-expanded="false">
			                                    <div>+ FILTRI</div>
											</a>
										</div>
									</div>					   	
									<div class="collapse" id="collapse-a" style="">
										<div class="row">    
											<div class="col-md-2 mt-1">
												<input value="" class="form-control form-control-sm" type="text" placeholder="N° Tessera Generica" v-model="search.NUMERO_TESSERA_GENERICA.VALUE">
											</div>
											<div class="col-md-2 mt-1">
												<select class="form-select form-select-sm" data-placeholder="Seleziona Stato Generica" v-model="search.STATO_TESSERA_GENERICA.VALUE">
													<option value="">Seleziona Stato Generica</option>
													<option value="ACTIVE"> ATTIVE</option>
													<option value="WORKING"> DA RICHIEDERE</option>
													<option value="PENDING"> DA ATTIVARE</option>
													<option value="NON_RINNOVATA"> NON RINNOVATA</option>
													<option value="DEACTIVE"> DISATTIVA</option>
												</select>
											</div>
											<div class="col-md-2 mt-1">
												<select class="form-select form-select-sm" data-placeholder="Seleziona Invio Generiche">
													<option value="">Seleziona Invio Generiche</option>
													<option value="3"> SPEDITE</option>
													<option value="4"> DA SPEDIRE</option>
													<option value="5"> RITIRO IN SEDE</option>
												</select> 
											</div>
											<div class="col-md-2 mt-1">
												<select class="form-select form-select-sm" data-placeholder="Seleziona Tutte">
													<option value="-1">Seleziona Tutte</option>
													<option value="0"> DA CONSEGNARE</option>
													<option value="1"> CONSEGNATE</option>
												</select> 
											</div>
											<div class="col-md-2 mt-1">
												<select class="form-select form-select-sm" data-placeholder="Seleziona Email RASPA">
													<option value="">Seleziona Email Raspa</option>
													<option value="5"> INVIATE</option>
													<option value="6"> DA INVIARE</option>
												</select> 
											</div>
											<div class="col-xs-12 col-sm-12 col-md-2 mt-1">
											</div>
										</div>
									</div>
								</form>
							</div> 
						</div>
					</div>	

			        <div class="card-body box-card mt-0 mb-0" id="box-card">
						<div class="div_table_resp tableFixHead" id="tableFixHead">
		               		<table class="table table-bordered table-hover table-striped table-togglable text-nowrap"> 
			                    <thead class="sticky-top">
									<tr class="bg-secondary text-white">
										<th class="table-head-sm" style="width:2%;"> <input id="chkAllTessere" v-on:click="filters.selectAll('chkAllTessere',paginatedList.arr)" type="checkbox" class=""> </th>
										<th class="table-head-sm" style="width:8%;"> #<span class="float-end">Ord. </span></th>
										<th class="table-head-sm text-center" style="width:4%;"> Img </th>
										<th class="table-head-sm" style="">Persona /<br>Ragione Sociale</th>
										<th class="table-head-sm text-center" style="width:20%;">Tessere</th>
										<th class="table-head-sm text-center" style="width:8%;">Stato</th>
										<th class="table-head-sm text-center" style="width:8%;">Lavorazione</th>
										<th class="table-head-sm text-center" style="width:8%;">Spedizioni</th>
										<th class="table-head-sm text-center" style="width:8%;">Consegnata</th>
										<th class="table-head-sm text-center" style="width:15%;">Note</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="tessera in paginatedList.arr" v-bind:key="tessera.ID_UNIVOCO">
										<td class="td-class text-center">
											<span class="footable-toggle"></span>
											<input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="tessera.SELEZIONATO" class=""> 
										</td>
										<td class="td-class fs-sm">
											<span>ID ORDINE</span><br />
											<small class="badge bg-light badge-xs text-primary cursor-pointer float-end"> Data ordine </small>
										</td>
										<td class="td-class text-center"> 
											<div v-show="tessera.FK_ID_TIPO == 0">
												<img v-if="tessera.ID_UTENTE > 0 && tessera.URL_AVATAR != 'placeholder.jpg'" :src="filters.getImgPath('USERS',tessera.URL_AVATAR)" class="rounded" style="width: 50px; height: 40px;" alt="" />
												<span class="btn-nophoto squared fs-sm" style="width: 50px; height: 40px !important; line-height: 10px; padding-top: 8px; font-size: 0.6rem !important;">No<br />Photo</span>
											</div>
										</td>

										<td class="td-class fs-sm">
											<span v-show="tessera.FK_ID_TIPO == 0" class="text-primary fw-bold cursor-pointer" v-on:click="openOffCanvas();openSchedaVisualizzazionePersonaFisica(tessera)">{{ tessera.COGNOME }} {{ tessera.NOME }} - {{ tessera.FK_ID_PERSONA_FISICA }}<br></span>
											<span v-show="tessera.FK_ID_TIPO == 0">
												<span class="badge bg-light badge-xs text-dark rounded-0 me-1" style="border: 1px #dddddd solid;" data-bs-toggle="tooltip" data-bs-placement="top" :title="tessera.EMAIL" v-bind:href="`tel:${tessera.EMAIL}`"><i class="fal fa-envelope fa-fw"></i> Email </span>																					
												<span class="badge bg-light badge-xs text-dark rounded-0 me-1" style="border: 1px #dddddd solid;" data-bs-toggle="tooltip" data-bs-placement="top" :title="tessera.TELEFONO" v-bind:href="`tel:${tessera.TELEFONO}`"><i class="fal fa-phone fa-fw"></i> Telefono </span>																					
											</span>                    
											<span v-show="tessera.FK_ID_TIPO > 0" class="text-dark cursor-pointer">{{ tessera.COGNOME }} {{ tessera.NOME }}<br>&nbsp;</span>                                								
										</td>
										<td class="td-class fs-sm">
											<div v-show="tessera.FK_ID_TIPO == 0">
												<div><i class="ph-check-circle fs-base lh-base align-top text-success me-1"></i> Tessera: <span class="text-primary">RASPA</span></div>
												<div><i class="ph-clock fs-base lh-base align-top text-danger me-1"></i> N° Tessera: <span class="text-primary">{{ tessera.NUMERO_TESSERA }}</span></div>
											</div>
											<div v-show="tessera.FK_ID_TIPO == 1">
												<div><i class="ph-check-circle fs-base lh-base align-top text-success me-1"></i> Tessera: <span class="text-primary">WTP</span></div>
												<div><i class="ph-clock fs-base lh-base align-top text-danger me-1"></i> N° Tessera: <span class="text-primary">{{ tessera.NUMERO_TESSERA_GENERICA }}</span></div>
											</div>
											<div v-show="tessera.FK_ID_TIPO == 2">
												<div><i class="ph-check-circle fs-base lh-base align-top text-success me-1"></i> Tessera: <span class="text-primary">GOSKIPASS</span></div>
												<div><i class="ph-clock fs-base lh-base align-top text-danger me-1"></i> N° Tessera: <span class="text-primary">{{ tessera.NUMERO_TESSERA_GENERICA }}</span></div>
											</div>
										</td>
										<td class="text-center">
											<span v-show="tessera.FK_ID_TIPO == 0" class="badge badge-xs bg-success">{{ tessera.STATO }}</span>
											<span v-show="tessera.FK_ID_TIPO > 0" class="badge badge-xs bg-success">{{ tessera.STATO_TESSERA_GENERICA }}</span>
										</td>
										<td class="text-center"><span v-show="tessera.FK_ID_TIPO > 0" class="badge bg-light text-secondary">stampata</span></td>
										<td class="text-center"><span v-show="tessera.FK_ID_TIPO > 0" class="badge bg-light text-danger">da spedire</span></td>
										<td class="text-center"><span v-show="tessera.FK_ID_TIPO > 0" class="badge bg-light text-primary">consegnata</span></td>
										<td class="text-center"><span v-show="tessera.FK_ID_TIPO > 0" class="text-muted">note</span></td>
									</tr>
								</tbody>
							</table>
						</div>
		
		                <div class="row page-bottom">
							<div class="col-12 col-md-5 d-none d-sm-block" :tabindex="27">
                                <div style="position: relative; top: 10px;">
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2">Tessere:: {{ paginatedList.count }}</span> 
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 ms-2">FATTURATO: </span>
                                </div>
                            </div>
							<div class="col-9 col-md-6" :tabindex="27">
		                        <div class="float-end pag-mobile">
									<Pagine v-model="search.PAGINATION.PAGE_NUMBER"  :numrighe="paginatedList.count"  :numpagine="search.PAGINATION.LENGTH"></Pagine>
								</div>
							</div>
							<div class="col-3 col-md-1" :tabindex="28">
								<select class="form-select form-select-sm wmin-100 mt-2 float-end" data-placeholder="Limite" :tabindex="20" v-model="search.PAGINATION.PAGE_SIZE" style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
									<option value="5">5</option>
									<option value="10">10</option>
									<option value="25">25</option>
									<option value="50">50</option>
									<option value="75">75</option>
									<option value="100">100</option>
									<option value="250">250</option>
									<option value="500">500</option>
								</select>
							</div>
						</div>	
					</div>	
				</div>
			</div>

			<div class="tab-pane fade" id="tessere-b">

				<div class="row">
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<i class="ph-users ph-2x text-primary me-3"></i>
								<div class="flex-fill text-end">
									<h4 class="mb-0"></h4>
									<span class="text-muted">Totale </span>
								</div>
							</div>
						</div>
					</div>
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<i class="ph-thumbs-up ph-2x text-success me-3"></i>

								<div class="flex-fill text-end">
									<h4 class="mb-0"></h4>
									<span class="text-muted">Utenti attivi</span>
								</div>
							</div>
						</div>
					</div>
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<i class="ph-thumbs-down ph-2x text-danger me-3"></i>
								<div class="flex-fill text-end">
									<h4 class="mb-0"></h4>
									<span class="text-muted">Utenti 0 pratiche</span>
								</div>
							</div>
						</div>
					</div>
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<div class="flex-fill">
									<h4 class="mb-0"></h4>
									<span class="text-muted">Utenti bannati</span>
								</div>
								<i class="ph-house-simple ph-2x text-danger ms-3"></i>
							</div>
						</div>
					</div>
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<div class="flex-fill">
									<h4 class="mb-0"> </h4>
									<span class="text-muted">Tot. Fatturato </span>
								</div>
								<i class="ph-sketch-logo ph-2x text-indigo ms-3"></i>
							</div>
						</div>
					</div>
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<div class="flex-fill">
									<h4 class="mb-0"></h4>
									<span class="text-muted">Tot. Fatturato  </span>
								</div>
								<i class="ph-globe-hemisphere-east ph-2x text-purple ms-3"></i>
							</div>
						</div>
					</div>
				</div>


			</div>

			<SchedaUtente :ref="'schedaUtente'" @updateGriglia="getUtenti();"></SchedaUtente>

		</div>
	</div>	


	<!-- START MODALI -->
    <div class="offcanvas offcanvas-end offcanvas-size-xlg" id="panel_right" data-bs-backdrop="false" role="dialog" tabindex="-1">
		<div class="offcanvas-header bg-secondary text-white" style="height: 3.96rem;">
			<h6 class="modal-title" style="width: 65% !important;">SCHEDA INFORMATIVA: </h6>  
			<div class="btn-group float-end" :tabindex="2">
				<a href="#" class="badge bg-light text-dark p-2 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">Azioni Marketing</a>
				<div class="dropdown-menu dropdown-position dropdown-menu-end" data-popper-placement="bottom-start" style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate3d(0px, 42px, 0px);">
					<a href="#" class="dropdown-item"><i class="fal fa-print fa-fw me-2"></i><span class="text-muted me-1">|</span>Stampa scheda </a>
					<a href="#" class="dropdown-item"><i class="fal fa-envelope fa-fw me-2"></i><span class="text-muted me-1">|</span>Invia email </a>
					<a href="#" class="dropdown-item"><i class="fal fa-paper-plane fa-fw me-2"></i><span class="text-muted me-1">|</span>Invia sms </a>
				</div>
			</div> 	
			<button type="button" class="btn-close text-white" data-bs-dismiss="offcanvas">X</button>
		</div>
		<div class="offcanvas-body p-2">
			<div v-show="pfHasUtente == 1">
				<SchedaVisualizzazioneUtente  :ref="'schedaVisualizzazioneUtente'"></SchedaVisualizzazioneUtente>
			</div>
			<div v-show="pfHasUtente == 0">
				<PersonaFisica v-model="personaFisicaSelezionata" :modalita="2" ></PersonaFisica>
			</div>			
		</div>
        <div class="border-top p-1 bg-light" style="position: relative; top: -1px;">
            <span class="btn btn-link float-end" data-bs-dismiss="offcanvas"><i class="fal fa-sign-out-alt fa-fw me-1"></i> CHIUDI</span>     
        </div>  
	</div>	

        
</template>



<script>

import Pagine from '@/components/utils/Pagine.vue'
//import ISwitch from '@/components/utils/ISwitch.vue'
import SchedaUtente from '@/components/SchedaUtente.vue'
import SchedaVisualizzazioneUtente from '@/components/SchedaVisualizzazioneUtente.vue'
import PersonaFisica from '@/components/common/PersonaFisica.vue'


export default {
    name:"CardsRangeTessere",

	
    components:{
        Pagine,
        //ISwitch,
        SchedaUtente,
		SchedaVisualizzazioneUtente,
		PersonaFisica

    },					  

    data: function (){
      	return{
            apiStartup:'raspa/range/tessere',
	        filters:global.filters,	
            GLOBAL_IMAGES_PATH:'',
			anno:new Date().getFullYear(),
			pfHasUtente:0,
			arrayTessere : new Array(),
			personaFisicaSelezionata:{},
	        search:{
	            PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:25},
                COGNOME:{TYPE:'TEXT',VALUE:''},
                NOME:{TYPE:'TEXT',VALUE:''},
				ID_ORDINE:{TYPE:'INT_RANGE',VALUE_DA:'',VALUE_A:''},
				NUMERO_TESSERA:{TYPE:'INT_RANGE',VALUE_FROM:'',VALUE_TO:''},
				FK_ID_TIPO:{TYPE:'COMBO',VALUE:''},
				NUMERO_TESSERA_GENERICA:{TYPE:'TEXT',VALUE:''},
				STATO:{TYPE:'COMBO',VALUE:''},
				STATO_TESSERA_GENERICA:{TYPE:'COMBO',VALUE:''},
				

				

				

	        },
			idRange:0,
			FK_ID_SEASON:0,
		//	utenteSelezionato:{personaFisica:{}},
			utenteCorrente:{},
      	}
    },

    methods: {
       
		getTessere : function(){
			utils.ajax(this.apiStartup,{ID_RANGE:this.idRange,FK_ID_SEASON:this.FK_ID_SEASON}, (response) => {
				this.arrayTessere = response.data;
				
			}); 
		},

		openOffCanvas : function(){
			var myOffcanvas = document.getElementById('panel_right')
			var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas)
			bsOffcanvas.show();
		},

		openSchedaVisualizzazionePersonaFisica : function(tessera,tab = "",opzioni = null){
			this.pfHasUtente = tessera.FK_ID_UTENTE > 0 ? 1 : 0;
			this.$forceUpdate();
			if (this.pfHasUtente == 0){
				utils.ajax("raspa/pf",{FK_ID_PERSONA_FISICA:tessera.FK_ID_PERSONA_FISICA}, (response) => {
					this.personaFisicaSelezionata = response.data;
				}); 		
			}
			else{
				this.$refs.schedaVisualizzazioneUtente.openSchedaVisualizzazioneUtente({ID_UTENTE:tessera.FK_ID_UTENTE});
			}
		},

		openRoute : function(route){
			global.router.push(route);
		},


   
    },

    computed: {
        paginatedList(){
            var arr = utils.inGrid(this.arrayTessere,this.search);
            return arr;
        },
	},	

	watch:{
	
	},

    created: function () {
        global.utils.BASE_API = process.env.VUE_APP_API_URL;
        this.GLOBAL_IMAGES_PATH = process.env.VUE_APP_GLOBAL_IMAGES_PATH;
        this.idRange = this.$root.appoggio.ID_RANGE;
		this.FK_ID_SEASON = this.$root.appoggio.FK_ID_SEASON;
		this.getTessere();
    },

}
</script>